/**
 * Shared merit / earning points rules for module content, classroom assessments, assignments, live classes, etc.
 */

export const MERIT_POINTS_MIN = 0;
export const MERIT_POINTS_MAX = 1000;

export function meritPointsValidationMessage(raw) {
  const s = String(raw ?? '').trim();
  if (s === '') return '';
  if (!/^\d+$/.test(s)) {
    return `Enter a whole number from ${MERIT_POINTS_MIN} to ${MERIT_POINTS_MAX}`;
  }
  const n = parseInt(s, 10);
  if (n < MERIT_POINTS_MIN || n > MERIT_POINTS_MAX) {
    return `Merit points must be between ${MERIT_POINTS_MIN} and ${MERIT_POINTS_MAX}`;
  }
  return '';
}

/** Same 0–1000 rules as meritPointsValidationMessage, but empty input is invalid. */
export function meritPointsValidationMessageRequired(raw) {
  const s = String(raw ?? '').trim();
  if (s === '') {
    return `Enter a whole number from ${MERIT_POINTS_MIN} to ${MERIT_POINTS_MAX}`;
  }
  return meritPointsValidationMessage(raw);
}

export function parseMeritPointsForApi(raw) {
  const s = String(raw ?? '').trim();
  if (s === '') return 0;
  const n = parseInt(s, 10);
  if (Number.isNaN(n)) return 0;
  return Math.min(MERIT_POINTS_MAX, Math.max(MERIT_POINTS_MIN, n));
}

/**
 * While typing / on blur: strip non-digits only — do not clamp. Range is enforced at submit
 * via meritPointsValidationMessage; parseMeritPointsForApi clamps only after validation passes.
 */
export function sanitizeMeritPointsDigits(raw) {
  return String(raw ?? '').replace(/\D/g, '');
}

/**
 * On blur: digits only — do not clamp. Out-of-range values stay visible so submit-time
 * validation can show an error (same idea as classroom assignments).
 */
export function formatMeritPointsOnBlur(raw) {
  return sanitizeMeritPointsDigits(raw);
}
